import { HolidaySweep, getStaticProps } from '@public/HolidaySweep'

export { getStaticProps }

export default HolidaySweep
